<template>
  <section class="blog-wrapper">
  <Banner />
  <div class="top-title">
{{ t('blog.top_title') }}
</div>
  <div class="container">
    <div class="blog-list">
      <div class="row justify-content-center">
        <div class="col-12">
        <div v-if="list.length" class="row">
          <h3>
          {{ t('blog.all_title') }}
          </h3>
          <div class="col-12 col-lg-8">
            <router-link v-for="(item, index) in list" :key="index" :to="getBlogLink(item)" target="_blank">
            <div class="blog-card">
              <img :src="item.signBannerUrl">
              <h4>{{ item.title }}</h4>
              <span>{{ t('blog.update_date') }} {{ item.createDate }}</span>
            </div>
            </router-link>
          </div>
          <!--<div class="col-12 col-lg-4">
              <div class="recommend-products">
                <h3>{{t('recommend.title')}}</h3>
                <h4>{{t('recommend.sub_title')}}</h4>
                <div class="product-card">
                </div>
              </div>
          </div>-->
        </div>
        </div>
      </div>
      <Pager
        :current="page"
        :max="totalPage"
        prefix="/blog/all"
      />
    </div>
  </div>
  </section>
</template>
<script>
import Pager from "~/components/layout/Pager";
import commonFunc from '~/assets/js/commonHelper.js'
import Banner from "~/components/layout/Banner";
export default {
  components: {
    Banner,
    Pager
  },
  data: function () {
    return {
      list: [],
      page: 1,
      totalPage: 1,
      pageSize: 10
    }
  },
  layout(context) {
    return "default";
  },
  head() {
    return {
      ...commonFunc.getSeoMeta(this.$store.state.layout.seo),
    }
  },
  computed: {},
  watch: {
    '$route'(to, from) {
      this.getResult()
    },
  },
  async asyncData({ store, route }) {
    await store.dispatch("layout/fetchBanner", { type: "blog" });
    const { page } = route.query
    const pageSize = 10
    await store.dispatch("blog/fetchList", { limit: pageSize, page: page || 1, type: "" });
    const data = JSON.parse(JSON.stringify(store.state.blog.list))
    const list = data.records || []
    const totalPage = Math.ceil(data.total / pageSize)
    await store.dispatch("layout/fetchSeo", {
      path: route.path
    });
    return { list: list, page: page || 1, totalPage: totalPage }
  },
  mounted() {
  },
  methods: {
    getResult: async function () {
      const page = this.$route.query.page
      this.page = page
      await this.$store.dispatch("blog/fetchList", { limit: this.pageSize, page: page || 1, type: "" });
      const data = JSON.parse(JSON.stringify(this.$store.state.blog.list))
      this.list = data.records || []
    },
    getBlogLink: function(item) {
      const path = '/blog/'
      const title = item.title.replace(/[?]/g, "-")
      return path + commonFunc.slugify(title + '-' + item.id)
    },
    formSubmit: function (e) {
      const data = {
        email: this.email
      }
      if (this.submitting || this.submitted) {
        e.preventDefault();
        return
      }
      this.submitting = true;
      const vm = this
      vm.$axios
        .post("subscribe", data)
        .then(function (response) {
          console.log(response.data)
          if (response.data.success) {
            commonFunc.toast(vm.t('blog.subscribe_success'), 'success')
            vm.submitted = true;
          } else {
            commonFunc.toast(vm.t('blog.subscribe_fail'), 'danger')
          }
          vm.submitting = false;
        }).catch((e) => {
          commonFunc.toast(vm.t('blog.subscribe_fail'), 'danger')
          vm.submitting = false;
        });
      e.preventDefault();
      return false;
    }
  },
};
</script>